import type { RootState as S } from 'store';

export const deliveryAreaArrayResultSelector = (store: S) => store.shopData.deliveryAreaArray.result;
export const deliveryAreaResultSelector = (store: S) => store.shopData.deliveryArea.result
export const deliveryOfCostResultSelector = (store: S) => store.shopData.deliveryOfCost.result;
export const discountersSelector = (store: S) => store.shopData.discounters;
export const territoriesDeliverySelector = (store: S) => store.shopData.territoriesDelivery.result;
export const settingsResultSelector = (store: S) => store.shopData.settings.result[0]
